export default "__VITE_ASSET__CTtS1Qsf__"